'use client';

import { createChartIsland } from '@/components/charts/_shared/createChartIsland';
import {
  STATE_CHART_ASPECT_RATIO,
  STATE_CHART_ASPECT_RATIO_MOBILE,
  STATE_CHART_MAX_WIDTH_REM,
} from '@/constants/stateCharts';

import type { RedListCategoriesChartProps } from '@/content/data/charts/red-list-categories';
import type { CSSProperties } from 'react';

const styleVars = {
  '--chart-aspect-ratio': String(STATE_CHART_ASPECT_RATIO),
  '--chart-aspect-ratio-mobile': String(STATE_CHART_ASPECT_RATIO_MOBILE),
  '--chart-max-width': `${STATE_CHART_MAX_WIDTH_REM}rem`,
} as CSSProperties;

/**
 * Client boundary for the below-fold Red List Categories chart.
 * Code-splits visx/motion; defers import until near the viewport.
 */
export const RedListCategoriesChartIsland =
  createChartIsland<RedListCategoriesChartProps>({
    loader: () =>
      import('./RedListCategoriesChart').then(
        (mod) => mod.RedListCategoriesChart,
      ),
    loadingAriaLabel: 'Loading Red List categories chart',
    styleVars,
  });
